import React from "react";
import "../Styles/Footer.css"; // for styles

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        <span className="label">Support :</span>{" "}
        <a href="tel:+971 50 6440253" className="link">+971 50 6440253|</a> 
        <a href="mailto:info@dxbhabibi.com " className="link">info@dxbhabibi.com </a>
      </p>
    </footer>
  );
}
